<template>
    <transition-group name="fade" mode="out-in">
        <div
            v-show="showBanner && hasResults"
            key="banner"
            class="products-table__configurable-product-banner px-container items-center mt-6 flex flex-col gap-4"
        >
            <p class="font-bold">Your search contains configurable products</p>

            <a
                href="/configurable-power-supplies"
                class="group inline-flex items-center gap-3 px-6 py-4 bg-xp-electron-green hover:bg-xp-green-over rounded-sm"
            >
                <span class="text-xs lg:text-sm font-bold uppercase tracking-[2.5px] text-black">
                    Configurable Products
                </span>
                <svg class="shrink-0 text-black group-hover:translate-x-1 transition-transform" width="38" height="13" viewBox="0 0 38 13" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M31.3202 11.3001L36.3602 6.41757L31.3202 1.53506" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round" /><path d="M35.4 6.44L1.55994 6.43997" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" /></svg>
            </a>
        </div>
        <product-series-list
            v-show="showSeries && type !== 'rf-power'"
            key="series"
            :series="true"
            :endpoint="seriesEndpoint"
            :filters-query-string="filtersQueryString"
            :limit="limit"
            @product-list-updated="updateProductCount"
        />
        <product-model-list
            v-show="!showSeries || type === 'rf-power'"
            key="models"
            :type="type"
            :endpoint="modelEndpoint"
            :filters-query-string="filtersQueryString"
            :limit="limit"
            :stock-check-endpoint="stockCheckEndpoint"
            @product-list-updated="updateProductCount"
        />
    </transition-group>
</template>

<script>
import ProductSeriesList from "./ProductSeriesList";
import ProductModelList from "./ProductModelList";

export default {
    name: "ProductList",
    components: { ProductSeriesList, ProductModelList },
    props: {
        modelEndpoint: {
            type: String,
            required: true,
        },
        seriesEndpoint: {
            type: String,
            required: true,
        },
        stockCheckEndpoint: {
            type: String,
            required: true,
        },
        filtersQueryString: {
            type: String,
            required: true,
        },
        showSeries: {
            type: Boolean,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        limit: {
            type: Number,
            required: true,
        },
        showBanner: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        updateProductCount(series, count) {
            this.$emit("product-list-updated", series, count);
        },
    },
    computed: {
        hasResults() {
            const key = this.showSeries ? "series" : "model";

            return (
                !this.$parent.count[key].loading &&
                this.$parent.count[key].count
            );
        },
    },
};
</script>
